// extracted by mini-css-extract-plugin
export var benefitscontainer = "benefits-module--benefitscontainer--hJB9K";
export var secondaryHeading = "benefits-module--secondaryHeading--F98H2";
export var content = "benefits-module--content--VphJ7";
export var contentCard = "benefits-module--contentCard--uIIcC";
export var contentHeading = "benefits-module--contentHeading--Ip1U0";